export default __webpack_public_path__ + "static/media/bateriaelectronica.d01b6dfe.png";